const env = {
  mode: process.env.NODE_ENV,
  api: {
    SPRING_API_URL: process.env.VUE_APP_SPRING_API_URL,
    KAKAO_MAP_API_URL: process.env.VUE_APP_KAKAO_MAP_API_URL,
    KAKAO_MAP_API_KEY: process.env.VUE_APP_KAKAO_MAP_API_KEY,
    STORE_ID: process.env.VUE_APP_STORE_ID,
    CHANNEL_KEY: process.env.VUE_APP_CHANNEL_KEY,
    CPID: process.env.VUE_APP_CPID,
    KIWOOM_URL: process.env.VUE_APP_KIWOOM_URL,
    KIWOOM_TAXFREECD: process.env.VUE_APP_KIWOOM_TAXFREECD,
    DANAL_CHANNEL_KEY: process.env.VUE_APP_DANAL_CHANNEL_KEY
  },
};

export default env;